import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CheckIndicator from '../checkindicator/CheckIndicator'
import MainButton from '../common/util/input/MainButton'
import { sleep } from '../helpers/FormatLinks'
import { getBoostAction } from '../helpers/WaxApi'
import LoadingIndicator from '../loadingindicator/LoadingIndicator'
import ErrorMessage from './ErrorMessage'
import Popup from './Popup'

function BulkDistributePopup(props) {
    const assets = props['assets']
    const { t } = useTranslation('common')
    const memo = props['memo']

    const ual = props['ual'] ? props['ual'] : { activeUser: null }
    const activeUser = ual['activeUser']

    const callBack = props['callBack']

    const userName = activeUser ? activeUser['accountName'] : null
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const closeCallBack = props['closeCallBack']
    const [errors, setErrors] = useState({})
    const [distributed, setDistributed] = useState([])
    const [transactions, setTransactions] = useState({})

    const maxActions = 10

    const addError = (assetId, e) => {
        errors[assetId] = e
        setErrors(errors)
    }

    const addTransaction = (assetId, tx) => {
        transactions[assetId] = tx
        setTransactions(transactions)
    }

    const [currentDisplayAction, setCurrentDisplayAction] = useState(0)

    const distribute = async () => {
        setIsLoading(true)

        let currentAction = 0

        while (currentAction < Object.keys(assets).length / maxActions) {
            const start = currentAction * maxActions
            const end = start + maxActions
            const actions = [getBoostAction(activeUser)]

            let distributeError = null

            Object.keys(assets)
                .sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
                .slice(start, end)
                .map((assetId) => {
                    const asset = assets[assetId].asset
                    const receiver = assets[assetId].receiver
                        .trim()
                        .toLowerCase()

                    if (asset.standard === 'atomicassets') {
                        actions.push({
                            account: 'atomicassets',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser['requestPermission'],
                                },
                            ],
                            data: {
                                from: userName,
                                memo: memo
                                    ? memo
                                    : 'nfthive.io bulk distribution',
                                asset_ids: [assetId],
                                to: receiver,
                            },
                        })
                    } else {
                        actions.push({
                            account: 'simpleassets',
                            name: 'transfer',
                            authorization: [
                                {
                                    actor: userName,
                                    permission: activeUser['requestPermission'],
                                },
                            ],
                            data: {
                                from: userName,
                                to: receiver,
                                assetids: [assetId],
                                memo: memo
                                    ? memo
                                    : 'nfthive.io bulk distribution',
                            },
                        })
                    }
                })

            try {
                const result = await activeUser.signTransaction(
                    {
                        actions: actions,
                    },
                    {
                        expireSeconds: 300,
                        blocksBehind: 0,
                    },
                )
                Object.keys(assets)
                    .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                    .slice(start, end)
                    .map((assetId) =>
                        addTransaction(assetId, result['transactionId']),
                    )
            } catch (e) {
                Object.keys(assets)
                    .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                    .slice(start, end)
                    .map((assetId) => addError(assetId, e.message))
                console.log(e)
                setError(e.message)
                distributeError = e
            } finally {
                currentAction += 1
                setCurrentDisplayAction(currentAction)
                if (!error && !distributeError) {
                    Object.keys(assets)
                        .sort((a, b) => parseInt(a.value) - parseInt(b.value))
                        .slice(start, end)
                        .map((assetId) => distributed.push(assets[assetId]))
                    setDistributed(distributed)
                }
                if (currentAction < Object.keys(assets).length / maxActions) {
                    sleep(1000)
                }
            }
        }
        setIsLoading(false)
        callBack({
            distributed: distributed,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    let distributeInfo = t('search.bulk_distribute')

    const distributeField = (
        <MainButton className="PopupSellButton" onClick={distribute}>
            {distributeInfo}
        </MainButton>
    )

    const cancel = () => {
        callBack({
            distributed: distributed,
            errors: errors,
            transactionIds: transactions,
        })
        closeCallBack()
    }

    return (
        <Popup title={t('search.bulk_distribute')} cancel={cancel}>
            {Object.keys(distributed).length > 0 ? <CheckIndicator /> : ''}
            {Object.keys(distributed).length === 0 ? (
                <div className="mx-auto text-xl font-bold mb-4">
                    {memo
                        ? `Are you sure you want to distribute these ${
                              Object.keys(assets).length
                          } Asset(s) with the Memo '${memo}' ?`
                        : t(
                              'popups.are_you_sure_you_want_to_distribute_assets',
                              {
                                  x: Object.keys(assets).length,
                              },
                          )}
                </div>
            ) : (
                ''
            )}
            {error ? <ErrorMessage error={error} /> : ''}
            {Object.keys(distributed).length === 0 ? (
                <div className="Buttons">
                    <MainButton className="PopupCancelButton" onClick={cancel}>
                        {t('asset.cancel')}
                    </MainButton>
                    {distributeField}
                </div>
            ) : (
                ''
            )}
            {isLoading ? (
                <div className="Overlay">
                    <LoadingIndicator
                        text={`Loading Transactions - Adding wait time to avoid Rate Limiting - Tx ${currentDisplayAction} / ${Math.ceil(
                            Object.keys(assets).length / maxActions,
                        )}`}
                    />
                </div>
            ) : (
                ''
            )}
        </Popup>
    )
}

export default BulkDistributePopup
